import React, { memo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { Box } from '@atlaskit/primitives/compiled';

import type { linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$key } from '@atlassian/jira-relay/src/__generated__/linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell.graphql';

export type Props = {
	fieldRef: linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$key;
};

export const LinkRelationshipTypeCell = memo<Props>(({ fieldRef }: Props) => {
	const data = useFragment<linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$key>(
		graphql`
			fragment linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell on JiraIssueLinkRelationshipTypeField {
				issueLink {
					relationName
				}
			}
		`,
		fieldRef,
	);

	return (
		<Box testId="native-issue-table.common.ui.issue-cells.link-relationship-type.link-relationship-type-cell">
			{data?.issueLink?.relationName}
		</Box>
	);
});
